import { checkResponse } from "src/components/js/statics1";

export async function getCookieConsent(personId, token) {
  const url = "/api/person/getCookieConsent/" + personId;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "cookieClass.js:getCookieConsent");
  return cResponse.data;
}

export async function setCookieConsent(personId, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      personId: personId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/person/setCookieConsent",
    requestOptions
  ).catch((error) => {
    console.error("Error:", error);
  });
  return (await checkResponse(response, "cookieClass.js:setCookieConsent")).success;
}
